<template>
    <div v-loading="items.meta.loading">
        <div class="header-with-line">
            <img src="/images/dashboard/calendar.svg" />
            <h2>Calendars</h2>
            <div class="line"></div>
        </div>
        <el-table
            class="mt-20 el-table--no-border el-table--no-header"
            :data="tableData"
        >
            <el-table-column prop="location.name" label="Calendar Name" />
            <el-table-column
                prop="location.calendar_format"
                label="Calendar Format"
            >
                <template slot-scope="{ row }">
                    {{
                        row.location.calendar_format === CalendarFormats.WEEKLY
                            ? "Weekly"
                            : "Monthly"
                    }}
                    Format
                </template>
            </el-table-column>
            <el-table-column label="Issue" prop="issue" />
            <el-table-column prop="actions">
                <template slot-scope="{ row }">
                    <el-button-group>
                        <el-button
                            type="info"
                            round
                            v-if="current_community.suspended"
                            >Suspended</el-button
                        >
                        <el-button
                            round
                            class="el-button--corwin-green"
                            style="width: 185px"
                            @click="editItem(row.calendar, row.location)"
                            v-else
                        >
                            {{ row.button_text }}
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import * as Routes from "@/constants/routes";
import * as CalendarStatus from "@/constants/calendar-statuses";
import * as Getters from "@/store/constants/getters";
import * as CalendarFormats from "@/constants/calendar-formats";

export default {
    data() {
        return {
            CalendarFormats,
            items: {
                data: [],
                meta: {
                    loading: false,
                },
            },
        };
    },
    computed: {
        ...mapState({
            locations: (state) => state.current_community.locations.data,
            current_community: (state) => state.current_community,
        }),
        ...mapGetters([
            Getters.CURRENT_MONTH,
            Getters.MONTHLY_CALENDAR_LOCATIONS,
        ]),
        tableData() {
            return _.map(this.locations, (location) => {
                let calendar = _.find(this.items.data, {
                    community_location_id: location.id,
                    year: this[Getters.CURRENT_MONTH].year(),
                    month: this[Getters.CURRENT_MONTH].month() + 1,
                });
                let button_text;
                switch (_.get(calendar, "status")) {
                    case CalendarStatus.IN_PROGRESS:
                        button_text = "Continue Working";
                        break;
                    case CalendarStatus.IN_SHOPPING_CART:
                        button_text = "In Shopping Cart";
                        break;
                    case CalendarStatus.READY_TO_BEGIN:
                    default:
                        button_text = "Get Started";
                        break;
                }
                return {
                    calendar,
                    location,
                    status: _.get(
                        calendar,
                        "status",
                        CalendarStatus.READY_TO_BEGIN
                    ),
                    button_text,
                    issue:
                        this[Getters.CURRENT_MONTH].format("MMMM YYYY") +
                        " Issue",
                };
            });
        },
    },
    mounted() {
        this.fetchItems();
    },
    methods: {
        fetchItems() {
            this.items.meta.loading = true;
            axios
                .get(`/web-api/calendar`, {
                    params: {
                        include_ordered: 1,
                    },
                })
                .then((response) => {
                    this.items.data = response.data.data;
                })
                .finally(() => {
                    this.items.meta.loading = false;
                });
        },
        editItem(item, location) {
            if (!item) {
                let query = {
                    location_id: location.id,
                    is_weekly:
                        location.calendar_format === CalendarFormats.WEEKLY
                            ? 1
                            : 0,
                };
                this.$router.push({
                    name: Routes.CREATE_CALENDAR,
                    query,
                });
            } else {
                this.$router.push({
                    name: Routes.EDIT_CALENDAR,
                    params: {
                        id: item.id,
                    },
                });
            }
        },
    },
};
</script>

<style scoped></style>
